<!-- 设备信息 -->
<template>
  <div class="device-info">
    <div class="device-detail-title os-font-14-500">维修设备及故障</div>
    <div class="device-detail-info" :class="{ 'shop-type': shopOrderInfo.modelName }">
      <div class="device-detail-info-left">
        <img
          :src="selectedModel.picture || require('@/assets/img/repair/base/wap/phone.png')"
          alt=""
        />
      </div>
      <div v-if="shopOrderInfo.modelName" class="device-detail-info-right">
        <div class="info-right-phone os-font-14-500">
          {{ shopOrderInfo.modelName }}
        </div>
        <div class="info-right-detail os-font-12-400">故障类型：{{ shopOrderInfo.faultDesc }}</div>
      </div>
      <div v-else class="device-detail-info-right">
        <div class="info-right-phone os-font-14-500">
          {{ selectedModel.name }}
          <div v-if="selectedModel.isNative == 1" class="self-phone os-font-10-500">本机</div>
          <div v-else-if="selectedModel.isMineProduct" class="self-phone os-font-10-500">
            我的设备
          </div>
        </div>
        <div class="info-right-detail os-font-12-400">故障类型：{{ selectedProblemList.name }}</div>
      </div>
    </div>
    <div class="device-etimate-price" v-if="!shopOrderInfo.modelName">
      <div class="price-total os-font-14-400">
        <div class="price-total-left">预估总费用</div>
        <div v-if="totalPrice" class="price-total-right os-font-14-500" @click="showPricePopup">
          ￥{{ totalPrice | formatMoney }}
        </div>
        <div v-else class="price-total-noprice">待检测评估</div>
      </div>
      <div v-if="repairType == 6" class="price-repair price-repair-base os-font-12-400">
        <div class="price-repair-left">预估维修费（不含人工费）</div>
        <div v-if="componentPriceData.totalPrice" class="price-repair-right">
          ￥{{ componentPriceData.totalPrice | formatMoney }}
        </div>
        <div v-else class="price-total-noprice">--</div>
      </div>
      <div v-if="repairType == 6" class="price-repair os-font-12-400">
        <div class="price-repair-left">预估往返配送费</div>
        <div class="price-repair-right">
          {{
            distributionFeeData.isAddressFilled
              ? `￥${distributionFeeData.totalShippingFee}`
              : '填写取件地址后展示'
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'deviceInfo',
  computed: {
    // 维修类型（1-预约，2-寄修，3-上门维修，6-同城快修）
    ...mapState('repair', [
      'repairType',
      'selectedModel',
      'selectedProblemList',
      'componentPriceData',
      'distributionFeeData',
      'shopOrderInfo'
    ]),
    totalPrice() {
      // 计算维修总费用
      if (this.repairType === 6) {
        return this.distributionFeeData.isAddressFilled
          ? Number(this.componentPriceData.totalPrice) +
              Number(this.distributionFeeData.totalShippingFee)
          : this.componentPriceData.totalPrice
      } else {
        return this.componentPriceData.totalPrice
      }
    }
  },
  methods: {
    showPricePopup() {
      this.$emit('showPricePopup')
    }
  }
}
</script>

<style lang="scss" scoped>
.device-info {
  border-radius: 12px;
  background: #fff;
  padding: 16px 16px;
  margin: 0 16px;
  max-width: 664px;
  box-sizing: border-box;

  .vivo-dark-mode & {
    background-color: #1e1e1e;
  }

  @media screen and (min-width: 698px) {
    margin: 0 auto;
  }

  .device-detail-title {
    padding-bottom: 16px;
    box-sizing: border-box;
    border-bottom: 1px solid #f5f5f5;
  }

  .device-detail-info {
    display: flex;
    justify-content: space-between;
    padding: 16px 0;

    &.shop-type {
      padding-bottom: 0;
    }

    .device-detail-info-left {
      width: 56px;
      height: 56px;
      border-radius: 6px;
      background: #f7f7f7;
      display: flex;
      align-items: center;
      justify-content: center;

      .vivo-dark-mode & {
        background-color: #fff;
      }

      img {
        width: 40px;
        height: 40px;
      }
    }

    .device-detail-info-right {
      padding-top: 8px;
      flex: 1;
      margin-left: 12px;

      .info-right-phone {
        height: 18px;
        display: flex;
        align-items: center;
        color: #333;

        .self-phone {
          margin-left: 6px;
          border-radius: 3px;
          padding: 2px 3px;
          box-sizing: border-box;
          color: #fff;
          background-color: #415fff;

          .vivo-dark-mode & {
            background-color: #3a56e6;
          }
        }
      }

      .info-right-detail {
        margin-top: 3px;
        color: #999;
        line-height: 18px;
      }
    }
  }

  .device-etimate-price {
    .price-total {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .price-total-left {
        color: #333;
      }

      .price-total-right {
        display: flex;
        align-items: center;
        color: #f10313;
        // font-weight: 500;
        &::after {
          display: block;
          content: '';
          margin-left: 4px;
          width: 16px;
          height: 16px;
          background: url('~@/assets/img/repair/confirm/wap/right-icon.svg') center center no-repeat;
          background-size: contain;
          margin-right: -6px;
        }
      }
    }

    .price-repair {
      margin-top: 12px;
      display: flex;
      justify-content: space-between;
      height: 18px;
      line-height: 18px;

      &.price-repair-base {
        margin-top: 16px;
      }

      .price-repair-left {
        color: #999;
      }

      .price-repair-right {
        color: #333;
      }
    }
  }
}
</style>
